import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";

export interface IRecordExpiredFurtherEducationListItem {
    id: string;
    recordId: string;
    name: string;
    validityEndDate: number;
    recordUserCode: string;
    recordFirstName: string;
    recordLastName: string;
    recordPicture: string;
    recordBirthDate: number;
    recordArchived: boolean;
    attachments: IIdTitle[];
    sharedByCompanyName: string;
    sharedToCompanies: string[];

    getName(): string;
}

export class RecordExpiredFurtherEducationListItem implements IRecordExpiredFurtherEducationListItem {
    id: string;
    recordId: string;
    name: string;
    validityEndDate: number;
    recordUserCode: string;
    recordFirstName: string;
    recordLastName: string;
    recordPicture: string;
    recordBirthDate: number;
    recordArchived: boolean;
    attachments: IdTitle[];
    sharedByCompanyName: string;
    sharedToCompanies: string[];

    constructor();
    constructor(obj: IRecordExpiredFurtherEducationListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.recordId = obj && obj.recordId || "";
        this.name = obj && obj.name || "";
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.recordUserCode = obj && obj.recordUserCode || "";
        this.recordFirstName = obj && obj.recordFirstName || "";
        this.recordLastName = obj && obj.recordLastName || "";
        this.recordPicture = obj && obj.recordPicture || "";
        this.recordBirthDate = obj && obj.recordBirthDate || null;
        this.recordArchived = obj && obj.recordArchived || false;
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, IdTitle);
        this.sharedByCompanyName = obj && obj.sharedByCompanyName || "";
        this.sharedToCompanies = obj && obj.sharedToCompanies || [];
    }
    
    getName(): string {
        return ((this.recordLastName ?? "") + " " + (this.recordFirstName ?? "")).trim();
    }

    static sortRecordExpiredFurtherEducationListItemsByColumn(items: IRecordExpiredFurtherEducationListItem[], column: string, asc: boolean): IRecordExpiredFurtherEducationListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "validityEndDate") {
            return items.sort((a: IRecordExpiredFurtherEducationListItem, b: IRecordExpiredFurtherEducationListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else if (column === "lastName") {
            return items.sort((a: IRecordExpiredFurtherEducationListItem, b: IRecordExpiredFurtherEducationListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.recordLastName, b.recordLastName)); });
        } else if (column === "firstName") {
            return items.sort((a: IRecordExpiredFurtherEducationListItem, b: IRecordExpiredFurtherEducationListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.recordFirstName, b.recordFirstName)); });
        } else if (column === "birthDate") {
            return items.sort((a: IRecordExpiredFurtherEducationListItem, b: IRecordExpiredFurtherEducationListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.recordBirthDate, b.recordBirthDate)); });
        } else if (column === "attachments") {
            return items.sort((a: IRecordExpiredFurtherEducationListItem, b: IRecordExpiredFurtherEducationListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.attachments.length ? a.attachments[0].title : "", b.attachments.length ? b.attachments[0].title : "")); });
        } else {
            return items.sort((a: IRecordExpiredFurtherEducationListItem, b: IRecordExpiredFurtherEducationListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        }
    }
}